let timeOnSiteReached = false;
let scrollDepthReached = false;
let eventFired = false;

$(document).ready(function () {
    setTimeout(function () {
        timeOnSiteReached = true;
    }, 20000);
});

$(window).on("scroll", function () {
    if (amountScrolled() > 49) {
        scrollDepthReached = true;
    }
    if (timeOnSiteReached && scrollDepthReached) {
        fireEvent();
    }
});

function fireEvent() {
    if (!eventFired) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'adjustedBouncerate',
            'info': 'Nutzer hat Time-on-Site und Scroll-Depth erfüllt'
        });

        eventFired = true;
    }
}

function amountScrolled() {
    let winheight = $(window).height();
    let docheight = $(document).height();
    let scrollTop = $(window).scrollTop();
    let trackLength = docheight - winheight;
    let pctScrolled = Math.floor(scrollTop / trackLength * 100); // gets percentage scrolled (ie: 80 NaN if tracklength == 0)
    return parseInt(pctScrolled);
}

function validateEventConditions() {
    if (timeOnSiteReached && scrollDepthReached) {
        fireEvent();
    }
}
